import type { PropsWithChildren } from 'react';
import React from 'react';
import type { ConnectedProps } from 'react-redux';
import { connect } from 'react-redux';

import { useButtonClasses } from '@flywire/headlessui-tailwindcss';

import { SELECT_INSTITUTION_PATH } from 'constants/index';
import type { RootState } from 'reducers/types';
import { getAccessToken, getCurrentLocale } from 'selectors';
import { useTranslations } from 'utils';

type NewPaymentProps = ConnectedProps<typeof connector> & {
  className?: string;
  size?: 'full' | 'auto';
  tone?: 'primary' | 'secondary';
};

const NewPaymentComponent = ({
  accessToken,
  children,
  className,
  locale,
  size = 'auto',
  tone = 'primary',
}: PropsWithChildren<NewPaymentProps>) => {
  const i18n = useTranslations();
  const classes = useButtonClasses({
    tone,
    size,
    className,
  });

  if (!accessToken) {
    return null;
  }

  return (
    <a
      className={classes}
      href={`${SELECT_INSTITUTION_PATH}?language=${locale}`}
      data-testid="new-payment-button"
    >
      {children || i18n.t('newPayment')}
    </a>
  );
};

const mapStateToProps = (state: RootState) => ({
  accessToken: getAccessToken(state),
  locale: getCurrentLocale(state),
});

const connector = connect(mapStateToProps);
const NewPayment = connector(NewPaymentComponent);

export { NewPayment };
